export const CustomerContactValidation = (formData) => {
    const errors = {};
    debugger;
    if (!formData.formData.FirstName || !formData.formData.FirstName.trim()) {
        errors.FirstName = 'This field is required';
    }

    if (!formData.formData.SurName || !formData.formData.SurName.trim()) {
        errors.SurName = 'This field is required';
    }
    if (!formData.formData.ClientCompanyID || formData.formData.ClientCompanyID=="0") {
        errors.ClientCompanyID = 'This field is required';
    }
    if (formData.formData.Email) {
        if (!isValidEmail(formData.formData.Email)) {
            errors.Email = 'Please enter a valid email address';
        }
    }
    return errors;
};
const isValidEmail = (email) => {
    // You can implement a regex or use a library like validator.js to validate email format
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};
